import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
  accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { FormikProps } from "formik";
import { Stack, TextField } from "@mui/material";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowBackIosIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
      transform: "rotate(90deg)",
    },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
  ...theme.applyStyles("dark", {
    backgroundColor: "rgba(255, 255, 255, .05)",
  }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function NeededDesc({
  formik,
  taskData,
  schedulData,
  LogsData,
}: {
  formik: FormikProps<any>;
  taskData?: any;
  schedulData?: any;
  LogsData?: any[];
}) {
  const [expanded, setExpanded] = React.useState<string | false>("");

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  // Get previous description from task or schedule data
  const getPreviousDescription = () => {
    if (taskData?.desc) return taskData.desc;
    if (schedulData?.desc) return schedulData.desc;
    return "";
  };

  // Get latest description from logs
  const getLatestLogDescription = () => {
    if (LogsData && LogsData.length > 0) {
      const latestLog = LogsData[0]; // Assuming logs are sorted by date desc
      return latestLog.statusDesc || "";
    }
    return "";
  };

  const previousDesc = getPreviousDescription();
  const latestLogDesc = getLatestLogDescription();

  return (
    <div>
      <Accordion
        // expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>
            نیاز به توضیحات: {expanded === "panel2" ? "دارد" : "ندارد"}
            {previousDesc && (
              <Typography
                variant="caption"
                color="text.secondary"
                component="span"
                sx={{ ml: 1 }}
              >
                | توضیحات قبلی: {previousDesc}
              </Typography>
            )}
            {latestLogDesc && (
              <Typography
                variant="caption"
                color="text.secondary"
                component="span"
                sx={{ ml: 1 }}
              >
                | آخرین توضیحات: {latestLogDesc}
              </Typography>
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TextField
            {...formik.getFieldProps("desc")} // استفاده از ویژگی‌های فرمیک
            label="توضیحات"
            size="small"
            multiline
            rows={3}
            placeholder="توضیحات"
            error={formik.touched.desc && Boolean(formik.errors.desc)}
            helperText={(formik.touched.desc && formik.errors.desc) as boolean}
            variant="outlined"
            fullWidth
          />
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
